export enum EQueryKeysConstant {
  RP_LIMITS = 'rus poker limits',
  RP_BONUSES = 'rus poker bonuses',
  RP_STANDS = 'rus poker stands',
  RP_PAYOUTS = 'rus poker payouts',
  RP_GAMES = 'rus poker games',
  OPERATORS = 'operators',
  PLAYERS = 'players',
}

export const queryKeys = {
  rpGames: {
    base: ['rp-games'] as const,
    all: () => [...queryKeys.rpGames.base, 'list'] as const,
    allWithParams: (params: { limit: number; offset: number }) => {
      return [...queryKeys.rpGames.base, 'list', { ...params }] as const
    },
    byId: (gameId: number) => [...queryKeys.rpGames.base, 'detail', gameId] as const,
    sessionsById: (
      id: number,
      params: {
        limit?: number
        offset?: number
      }
    ) => [...queryKeys.rpGames.base, 'sessions', id, { ...params }] as const,
    sessionById: (gameId: number, sessionId: number) =>
      [...queryKeys.rpGames.base, 'sessions', gameId, sessionId] as const,
    boxesById: (gameId: number, sessionId: number) =>
      [...queryKeys.rpGames.base, 'sessions', gameId, sessionId, 'boxes'] as const,
  },
  // rpGameSessions: {
  //   all: ['rp-game-sessions'],
  //   byPublicId: (id: string) => [`rp-game-sessions`, id],
  // },
} as const
